export const useTransformValues = () => {
    const transformArrayField = (fieldValue) => {
        if (!Array.isArray(fieldValue)) {
            return [];
        }

        return fieldValue.filter(option => option.inputValue && !isNaN(option.inputValue)).map(option => ({
            id: option.id,
            name: option.name,
            count: Number(option.inputValue)
        }));
    }

    const transformDropdownField = (fieldValue, options) => {
        if (fieldValue === null || fieldValue === undefined || fieldValue === "") {
            return undefined;
        }

        return fieldValue;
    }

    const transformBooleanField = (id, options) => {
        if (id === null || id === undefined) {
            return undefined;
        }

        return id;
    }

    const transformFormValues = (formValues, fields) => {
        const transformValues = {};

        fields.forEach(field => {
            if (field.type === "multiselect") {
                transformValues[field.name] = transformArrayField(formValues[field.name] || []);
            } else if (field.type === "dropdown") {
                transformValues[field.name] = transformDropdownField(formValues[field.name], field.options || []);
            } else if (field.type === "boolean") {
                transformValues[field.name] = transformBooleanField(formValues[field.name], field.options);
            } else if (field.type === "multi_value") {
                const raw = formValues[field.name];
                transformValues[field.name] = Array.isArray(raw)
                    ? raw
                        .filter(obj => obj && (obj.name?.trim() || obj.position?.trim()))
                        .map(obj => ({
                            name: obj.name?.trim() ?? "",
                            position: obj.position?.trim() ?? ""
                        }))
                    : [];
            } else {
                transformValues[field.name] = formValues[field.name];
            }
        });

        return transformValues;
    }

    return { transformFormValues };
}